// Disable window scroll when fancybox open

jQuery(document).ready(function($) {
	if ($('body').hasClass('fancybox-active')) {
		$('html').css('overflow', 'hidden');
	} else {
		$('html').css('overflow', 'visible');
	}
});
